(function () {
    "use strict";

    angular
        .module("app")
        .service("ordersService", service);

    function service($http) {
        const self = this;

        self.searchCriteria = {
            customer_id: null,
            company_name: null,
            order_id: null,
            customer_order_no: null,
            order_from_date: null,
            order_to_date: null,
            item_id: null,
            shipping_contact_id: null,
            order_name: null,
            order_status: null,
            order_create_user: null
        };

        self.hasSearched = false;

        self.searchResults = [];

        self.total = () => self.searchResults.reduce((total, order) => total + order.order_total, 0);

        self.canSearch = () => {
            const sc = self.searchCriteria;
            return sc.order_id ||
                sc.customer_order_no ||
                (sc.order_from_date && sc.order_to_date);
        }

        self.search = () => {
            self.searchResults = [];
            self.hasSearched = false;

            // remove time from dates due to timezone
            const request = angular.copy(self.searchCriteria);
            if (request.order_from_date) request.order_from_date = moment(request.order_from_date).format("MM/DD/YYYY");
            if (request.order_to_date) request.order_to_date = moment(request.order_to_date).format("MM/DD/YYYY");

            return $http
                .post(`/api/orders/search`, request)
                .then(result => {
                    self.searchResults = result.data;
                    self.hasSearched = true;
                });
        };

        self.orderAgain = orderId => {
            return $http.post(`/api/orders/${orderId}/order-again`);
        };

        self.shippingLabelExists = orderId => {
            return $http.get(`/api/shipping-labels/${orderId}/exists/`);
        };

        self.getShippingLabel = orderId => {
            return $http.get(`/api/shipping-labels/${orderId}/`);
        };

        self.clear = () => {
            Object.keys(self.searchCriteria).forEach(key => self.searchCriteria[key] = null);
            self.searchCriteria.order_from_date = moment().subtract(45, "days").startOf("day").toDate();
            self.searchCriteria.order_to_date = moment().startOf("day").toDate();
            self.searchResults = [];
            self.hasSearched = false;
        }

        self.clear(); // set defaults
    }
    service.$inject = ["$http"];

})()